import { Children, type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";
import { Button, ButtonGroup } from "../../atoms/Button";

export interface EmptyStateActionsProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

// Row of primary/secondary actions -- children must be `Button` (or `Button.Group`) so an
// EmptyState's actions stay visually/behaviorally consistent with every other action surface.
export const EmptyStateActions = ({ className, ref, children, ...props }: EmptyStateActionsProps) => {
  if (process.env.NODE_ENV !== "production") {
    Children.forEach(children, (child) => {
      if (
        child &&
        typeof child === "object" &&
        "type" in child &&
        child.type !== Button &&
        child.type !== ButtonGroup
      ) {
        console.error("EmptyState.Actions only accepts Button or Button.Group children.");
      }
    });
  }

  return (
    <div
      ref={ref}
      data-slot="empty-state-actions"
      className={cn("flex flex-wrap items-center justify-center gap-2", className)}
      {...props}
    >
      {children}
    </div>
  );
};
